export default "__VITE_ASSET__BNVRlNTO__"